<agr-wrapper-site-sidenav [navigationItems]="navigationItems" data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
